import { createApi } from "@reduxjs/toolkit/query/react";
import { stringify } from "qs";

import { baseQuery } from "../../../shared/api/base-query";
import { TechOperationAssetEntityType } from "../../tech-operations/shared/types/tech-operation-asset-entity";
import { AssetStockBalanceDto } from "../shared/dtos/asset-stock-balance";
import { AssetStockBalancesResponseDto } from "../shared/dtos/asset-stock-balances-response";

const LARGE_PAGE_SIZE = 10000;

type FetchAssetStockBalancesArgs = {
  farmId: string;
  assetCategory?: TechOperationAssetEntityType[];
  name?: string[];
  measureUnit?: string[];
};

export type AssetStockBalancesResult = {
  items: AssetStockBalanceDto[];
  lastSyncAt: string;
  totalCount: number;
};

export const assetStockBalancesApiSlice = createApi({
  reducerPath: "api-asset-stocks",
  baseQuery,
  tagTypes: ["AssetStockBalances"],
  endpoints: (builder) => ({
    fetchAssetStockBalances: builder.query<
      AssetStockBalancesResult,
      FetchAssetStockBalancesArgs
    >({
      query: ({ farmId, assetCategory, name, measureUnit }) => {
        const params = stringify(
          {
            farmId: [farmId],
            ...(assetCategory?.length ? { assetCategory } : {}),
            ...(name?.length ? { name } : {}),
            ...(measureUnit?.length ? { measureUnit } : {}),
            pageSize: LARGE_PAGE_SIZE,
          },
          { arrayFormat: "repeat", encodeValuesOnly: true }
        );
        return { url: `AssetStockBalances?${params}`, method: "GET" };
      },
      providesTags: ["AssetStockBalances"],
      transformResponse: (
        response: AssetStockBalancesResponseDto
      ): AssetStockBalancesResult => ({
        items: response.data,
        lastSyncAt: response.meta.lastSyncAt,
        totalCount: response.meta.totalCount,
      }),
    }),
  }),
});

export const { useFetchAssetStockBalancesQuery } = assetStockBalancesApiSlice;
